import { Card, Loader } from "@egovernments/digit-ui-react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import BPADocuments from "./BPADocuments";
import TLCaption from "./TLCaption";
import Form12Summary from "../../Forms/Form12/Form12Summary";

function ApplicationDetailsContentForm12({
  applicationDetails,
  isLoading,
  setOnAddComments,
  edcrDetails,
  collectionBillDetails,
  workflowDetails,
  isDataLoading,
  applicationData,
  timelineStatusPrefix,
  showTimeLine = true,
  onActionSelect,
  forcedActionPrefix,
  submitAction,
  actionData,
  moduleCode,
  businessService,
  action,
  statusAttribute = "status"
}) {
  const { t } = useTranslation();

  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }

  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !(window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    }
    else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    }
    else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };
  return (
    <Card style={{ position: "relative" }}>
      {isLoading ? <Loader /> : (
        <Form12Summary
          onActionSelect={onActionSelect}
          setOnAddComments={setOnAddComments}
          formData={applicationDetails}
          showTimeLine={showTimeLine}
          workflowDetails={workflowDetails}
          edcrDetails={edcrDetails}
          collectionBillDetails={collectionBillDetails}
          timelineStatusPrefix={timelineStatusPrefix}
          isDataLoading={isDataLoading}
          forcedActionPrefix={forcedActionPrefix}
          submitAction={submitAction}
          actionData={actionData}
          moduleCode={moduleCode}
          applicationData={applicationData}
          action={action}
          businessService={businessService}
        />
      )}
      {!applicationDetails?.documents && (
        <BPADocuments
          t={t}
          applicationData={applicationDetails}
          docs={applicationDetails?.documents}
          bpaActionsDetails={workflowDetails}
        />
      )}
    </Card>
  );
}

export default ApplicationDetailsContentForm12;
